'use strict';
const React = require('react');
const BaseComponent = require('../../../../shared/base'); 
var CommonModule = require('../../../../../public/js/common');
var actionTypes = require('../../../../../redux/actionTypes');
let client = require('../../../../../../sdk/client');
const Currency = require('currency-symbol-map');

const toastr = require('toastr');

class SearchItemViewComponent extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            currentExchange: null,
            boolIsCalculate: false,
        }
    }

    componentDidMount(){
        this.subExchangeCurrencyLookup();  

        setTimeout(() => {
            this.loadSalePrices();
        }, 1000);
    }

    getCookie(name) {
        if(typeof window !== 'undefined'){
            var value = '; ' + document.cookie;
            var parts = value.split('; ' + name + '=');
            if (parts.length === 2) {
                return parts.pop().split(';').shift();
            }
        }
    }
    
    subExchangeCurrencyLookup()
    {
        let numExchangeCurrency = $("#exchange-currency").attr("currency");
        if (numExchangeCurrency != null && numExchangeCurrency != "-") {
            this.setState({
                "currentExchange":parseFloat(numExchangeCurrency),
                boolIsCalculate: true
                }, () => {
            })
        } else {
            var currentExchange = this.getCookie('CurrentExchange');
            console.log('currentExchange: ' + currentExchange);
            if (currentExchange == undefined) {
                setTimeout( () => {
                    this.subExchangeCurrencyLookup();
                }, 100);
            } else {
                if (isNaN(currentExchange)) {
                    currentExchange = process.env.DEFAULT_CURRENCY_VALUE;
                }

                document.querySelectorAll("#exchange-currency").forEach(el => {
                    el.setAttribute("currency", currentExchange);
                    el.textContent = "$ " + currentExchange.toString();
                });
                this.setState({
                    "currentExchange":parseFloat(currentExchange),
                    boolIsCalculate: true
                }, () => {
            })
            }
        }
    }

    renderRating(stars) {
        return (
            <div className="item-rating">
                <span className="stars"><span style={{ width: `${stars}%` }} /></span>
            </div>
        );
    }

    subFormatMoney(
        numAmount_I,
        intDecimalCount = 2,
        strDecimal = ".",
        strThousands = ","
    ) {
        try {
            intDecimalCount = Math.abs(intDecimalCount);
            intDecimalCount = isNaN(intDecimalCount) ? 2 : intDecimalCount;
            const negativeSign = numAmount_I < 0 ? "-" : "";

            let str_Z = parseInt(numAmount_I = Math.abs(Number(numAmount_I) || 0).toFixed(intDecimalCount)).toString();
            let str_Z2 = (str_Z.length > 3) ? str_Z.length % 3 : 0;

            return negativeSign + (str_Z2 ? str_Z.substr(0, str_Z2) + strThousands : '') +
                str_Z.substr(str_Z2).replace(/(\d{3})(?=\d)/g, "$1" +
                    strThousands) + (intDecimalCount ? strDecimal +
                        Math.abs(numAmount_I - str_Z).toFixed(intDecimalCount).slice(2) : "");
        } catch (e) {
            //console.log(e)
        }
    }

    loadSalePrices() {
        //                                                  //This id is taken from the widget.
        if (typeof window !== "undefined" && typeof document !== "undefined") {
            var depotId = document.getElementById("address-name").getAttribute("billing-address-lider");

            if (this.props.user) {
                if (this.props.user.Guest == false && (depotId != null && depotId != "")) {
                    var self = this;
                    let userType = this?.props?.user?.CustomFields != null ? this?.props?.user?.CustomFields.find(cf => cf.Name == "Tipo de Usuario")?.Values[0] : null;
                    let externalUserId =
                        this.props.user.CustomFields != null ? this.props.user.CustomFields.find(cf => cf.Name == "Cliente ID") : null
                    //To test: 
                    //let externalUserId = {Values:["215"]};

                    var arrOfParts = [];
                    
                    for(var i = 0; i < document.getElementsByClassName('item-name').length; i++){
                        if(i % 2 ==  0) {
                            arrOfParts.push({ "partCode": document.getElementsByClassName('item-name')[i].innerText});
                        }
                    }

                    const priceParams = {
                        deptoId: depotId,
                        //MXN currency by default
                        currencyCode: "MXN",
                        customerId: externalUserId != null ? externalUserId.Values[0] : "0",
                        //by default order type is Offer AKA Normal
                        orderTypeCode: userType != null && userType === "B2C" ? "PEDIDOS INTERNET" : "NORMAL",
                        detail: arrOfParts
                    };

                    client.BepensaPrices.getBepensaPricesByPartNumbers(priceParams).then(response => {
                        if (
                            response.Result != undefined && response.Result == 0 &&
                            response.PartsCode != undefined && response.PartsCode.length > 0
                        ) {
                            response.PartsCode.forEach(function (part, index) {

                                var partNumber = part.PartCode;
                                if (part.PartsPrices != null && part.PartsPrices[0] != null && part.PartsPrices[0].SalePrice != null) {
                                    document.getElementById('precioPublico' + partNumber).innerHTML = `<b>$ ${self.subFormatMoney(part.PartsPrices[0].PublicPrice)} MXN</b>`;
                                    
                                    if(userType != 'B2C') {
                                        if(part.PartsPrices[0].PublicPrice != part.PartsPrices[0].SalePrice) {
                                            document.getElementById('precioPublico' + partNumber).setAttribute('style', 'text-decoration: line-through;color: red !important;');
                                            document.getElementById('precioDescuento' + partNumber).innerHTML = ` <b>$ ${self.subFormatMoney(part.PartsPrices[0].SalePrice)} MXN</b>`;
                                        }
                                    }
                                }
                            });
                        }
                    });
                } else {
                    //                                              //If not loaded yet billing-address-lider try again on the
                    //                                              //      next second.
                    setTimeout(() => {
                        this.loadSalePrices();
                    }, 1000);
                }
            } else {
                //                                              //If not loaded yet billing-address-lider try again on the
                //                                              //      next second.
                setTimeout(() => {
                    this.loadSalePrices();
                }, 1000);
            }
        } else {
                //                                              //If not loaded yet billing-address-lider try again on the
                //                                              //      next second.
            setTimeout(() => {
                this.loadSalePrices();
            }, 1000);
        }
    }
    
    renderOffer(item, classPrecioCore) {
        //TODO: Change hardcoded Category for reusability	
        if(item.Categories.find(x => x.ID == process.env.OFFERS) != undefined && classPrecioCore == 'hide')
        {
            return (
                <div id="container-info-offerts-carousel">
                    <div id="icon-offers">
                     	<div id="star-offers-carousel">&#10040;</div>
                        <div id="character-offers-carousel">%</div>
                    </div>
                    <div id = "offers-text-carousel">Oferta</div>
			    </div>
            ); 
 	    } 
        else if(item.Categories.find(x => x.ID == process.env.OFFERS) != undefined && classPrecioCore != 'hide') 
        {
	        return (
                <div className="store-rating item-footer-images-container">
                    <div>
                    	<div id="container-info-offerts-carousel">
                       		<div id="icon-offers">
                        	    <div id="star-offers-carousel">&#10040;</div>
                            	<div id="character-offers-carousel">%</div>
                        	</div>
                        	<div id = "offers-text-carousel">Oferta</div>
		                    <div id="icon-recon-carousel">
                            	<div id="star-recon-carousel"><img alt="" style={{width:'14px'}} src="/assets/images/bepensa/recon-icon2-white.png" /></div>
                        	</div>
                        	<div id = "recon-text-carousel">Recon</div>
                    	</div>
                	</div>
                </div>
            );
	    } 
        else if(item.Categories.find(x => x.ID == process.env.OFFERS) == undefined && classPrecioCore != 'hide') 
        {
	        return (
                <div style={{ width: '100%', "textAlign": 'right' }}>
                    <div id="container-info-offerts-carousel-nooffer">
                        <div id="icon-recon-carousel">
                            <div id="star-recon-carousel"><img alt="" style={{width:'14px'}} src="/assets/images/bepensa/recon-icon2-white.png" /></div>
                        </div>
                        <div id = "recon-text-carousel">Recon</div>
	                </div>
                </div>
	        );
	    }
    }

    addItemToCart(e) {
        const { CurrencyCode, Media, Name, Price } = e;
        const self = this;

        var strCurrencyCode = "";
        var currencyCodeCf = e.CustomFields.find(x => x.Name == "Currency");   
        if (currencyCodeCf != undefined || currencyCodeCf != null) {
            if(currencyCodeCf.Values[0].length > 0){
                strCurrencyCode = currencyCodeCf.Values[0];
            }                       
        }
        var priceItem = e.Price;
        if(process.env.BASE_URL == "bepensab2c.staging.arcadier.io"){
            if(self.state != null && self.state.currentExchange != null && self.state.currentExchange != "-"){
                    
                let strMXNPrice = e.Price;
                    
                if(strCurrencyCode != "MXN"){
                    strMXNPrice = e.Price * self.state.currentExchange;
                }                        
                priceItem = strMXNPrice;
            }
        }

        let partNumberCf;
        try {
            partNumberCf = e.CustomFields.find(x => x.Code == process.env.CF_PART_NUMBER);
        } catch (error) {
            console.error(".Find error:", error);
        }
        let partNumber = "";

        if (partNumberCf != undefined) {
            partNumber = partNumberCf.Values[0];
        }

        var userIsB2C = true;
        try {
            if(self.props.user.Guest) {
                userIsB2C = true;
            } else {
                if(self.props.user.CustomFields) {
                    try {
                        userIsB2C = self.props.user.CustomFields.find(x => x.Name == "Tipo de Usuario").Values[0] === "B2C";
                    } catch (error) {
                        console.error(".Find error:", error);
                    }
                }
            }
        } catch(error) {
        }

        try {
            var avalExis = 0;
            if (typeof window !== "undefined" && typeof document !== "undefined") {
                avalExis = parseInt(document.getElementById("existenciasSearch" + partNumber).innerText);
            }
            if(avalExis > 0 ) {
                let item = e;
                var errPrompt = [];
                try {
                    if (self.props.processing === true) {
                        return;
                    }
                } catch(error) {
                }

                $('.minimum-order-not-met-error-container').hide();
                $('.not-enough-stock-error-container').hide();
                $('.required').removeClass('error-con');
                try {
                    if (self.props.user.Guest && self.props.controlFlags.GuestCheckoutEnabled === false) {
                        toastr.error('Feature not available yet for guest user.')
                        return;
                    }
                } catch(error) {
                }

                let hasEmpty = false;
                var userId;
                var numQty = e.CustomFields.find(x => x.Code == process.env.CF_SALES_UNIT);

                var priceValues = {
                    quantity: numQty.Values[0]
                };

                let guestUserID = "";
                //if (!self.props.user) {
                    if (CommonModule.getCookie("guestUserID") && CommonModule.getCookie("guestUserID") !== "") {
                        guestUserID = CommonModule.getCookie("guestUserID");
                    }
                ///} else {
                ///    userId = self.props.user.ID;
                //}

                console.log("guestUserID " + guestUserID);
                    //console.log("userId " + userId);

                const options = {
                    pageSize: 100,
                    pageNumber: 1,
                    includes: null,
                    guestUserID: guestUserID
                };

                let APIurl = "/cart/getUserCarts?pageSize=" + options.pageSize + "&pageNumber=" + options.pageNumber + "&includes=" + options.includes + "&guestUserID=" + options.guestUserID;

                var settings = {
                    "url": APIurl,
                    "method": "GET",
                    "timeout": 0,
                };

                $.ajax(settings).done(function (response) {
                    let cartList = [];
                    let cartCount = 0;
                    if (response.TotalRecords > 0 && response.Records) {
                        cartList = response.Records;
                        cartList.map(cart => cartCount += parseInt(cart.Quantity || 0));
                    }

                    cartList.map(function (cart) {
                        //ARC10053 the discountamount should not be round off to have the correct value.
                        if (cart.DiscountAmount) {
                            cart.DiscountAmount = parseFloat(cart.DiscountAmountNotRoundOff) || 0;
                        }
                    });

                    let quantityToPass = priceValues.quantity;
                    let cartItemId = null;

                    const itemExistsInCartLocal = cartList.find(cl => cl.ItemDetail.ID == e.ID);
                    if (process.env.PRICING_TYPE != 'service_level') {
                        const itemExistsInCart = cartList.find(cl => cl.ItemDetail.ID == e.ID);
                        cartItemId = itemExistsInCart ? itemExistsInCart.ID : null;
                        if (itemExistsInCart) {
                            quantityToPass = parseInt(priceValues.quantity) + parseInt(itemExistsInCart.Quantity);
                        }
                    }
                    if(itemExistsInCartLocal){
                        var itemQty = itemExistsInCartLocal.Quantity;
                        var qtyFinal = itemQty;
                        if ((qtyFinal + priceValues.quantity) > parseInt(priceValues.quantity) && self.isThisUserB2C === true) {
                            toastr.error('No hay suficiente stock para este producto, puedes contactar al vendedor para más información.', 'Error');
                            //self.props.setProcessing(false);
                            return;
                        } else {
                            const options = {
                                selectedQuantity: priceValues.quantity,
                                discount: priceValues.discount,
                                itemId: e.ID,
                                force: true,
                                isComparisonOnly: false,
                                ServiceBookingUnitGuid: null,
                                bookingSlot: null
                            };

                            window.gtag("event", "add_to_cart", {
                                'app_name': 'Megamak',
                                'item_added': 'Item: ' + e.BuyerDescription
                            });

                            const { CurrencyCode, Media, Name } = e;
                            const itemId = options.itemId;
                            const selectedQuantity = options.selectedQuantity || 0;
                            const discount = options.discount || 0;
                            const force = options.force;
                            const isComparisonOnly = options.isComparisonOnly;
                            const serviceBookingUnitGuid = options.serviceBookingUnitGuid || null;
                            const bookingSlot = options.bookingSlot;
                            const addOns = options.addOns;

                            $.ajax({
                                url: '/items/getItemDetails',
                                type: 'GET',
                                data: {
                                    itemId: e.ID
                                },
                                success: function (result) {
                                    e.IsVisibleToCustomer = result.IsVisibleToCustomer;
                                    e.IsAvailable = result.IsAvailable;
                                    e.Active = result.Active;

                                    if (e.Active) {
                                        let url = '/items/addCart';
                                        let method = 'POST';

                                        if (cartItemId) {
                                            url = '/items/editCart';
                                            method = 'PUT';
                                        }
                                        let guestUserID = "";
                                        if (CommonModule.getCookie("guestUserID") && CommonModule.getCookie("guestUserID") !== "") {
                                            guestUserID = CommonModule.getCookie("guestUserID");
                                        }

                                        //fix
                                        var quantity = 1;
                                        $.ajax({
                                            url: url,
                                            type: method,
                                            data: {
                                                cartItemId: cartItemId,
                                                quantity: quantity,
                                                discount: discount,
                                                itemId: itemId,
                                                force: force,
                                                forComparison: isComparisonOnly,
                                                guestUserID: guestUserID,                            
                                                serviceBookingUnitGuid: serviceBookingUnitGuid,
                                                bookingSlot: bookingSlot ? JSON.stringify(bookingSlot) : null,
                                                addOns: addOns ? JSON.stringify(addOns) : null,
                                            },
                                            success: function (result) {
                                                if (result.ID == null && result.Code && !options.isComparisonOnly) {
                                                    if (result.Code == 'INSUFFICIENT_STOCK') {
                                                        if (typeof failedCallback === 'function') {
                                                            failedCallback(EnumCoreModule.GetToastStr().Error.INSUFFICIENT_STOCK);
                                                        }
                                                    } else if (result.Code == 'INVALID_SERVICE_BOOKING') {
                                                        if (typeof failedCallback === 'function') {
                                                        failedCallback(EnumCoreModule.GetToastStr().Error.INVALID_SERVICE_BOOKING);
                                                        }
                                                    }
                                                return dispatch({
                                                        type: '',
                                                    });
                                                }
                                                if (result.AccessToken && result.AccessToken.UserId) {
                                                CommonModule.createCookie("guestUserID", result.AccessToken.UserId, 1);
                                                }
                                                if (e.HasChildItems && e.ChildItems) {
                                                    e.ChildItems.forEach(function (child) {
                                                        if (child.ID === itemId) {
                                                            if (child.StockLimited === true && !isComparisonOnly) {
                                                                //ARC9590
                                                                child.StockQuantity = parseInt(child.StockQuantity) - parseInt(selectedQuantity);
                                                            }
                                                        }
                                                    });
                                                } else {
                                                    if (!isComparisonOnly) {
                                                        e.StockQuantity = parseInt(e.StockQuantity) - parseInt(selectedQuantity);
                                                    }
                                                }

                                                if (typeof successCallback === 'function') {
                                                    successCallback(result);
                                                }

                                                //toastr.success("Artículo agregado al carrito.");
                                                if (typeof window !== "undefined" && typeof document !== "undefined") {
                                                    document.getElementById('latest-cart-count').innerText = parseInt(document.getElementById('latest-cart-count').innerText) + parseInt(priceValues.quantity);
                                                }
                                                $(".h-cart .h-dd-menu.add-cart").addClass('fadeout');
                                                $('.h-cart .h-dd-menu.add-cart.fadeout').css('display', '');


                                                $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > p').text(Name);
                                                $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > .item-price > .currency').text(`${CurrencyCode} ${Currency(CurrencyCode)}`);
                                                $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > .item-price > .value').text(priceItem);
                                                $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-img > img').attr('src', Media[0].MediaUrl);

                                                
                                                setTimeout(function () {
                                                    var target = $(".h-cart .h-dd-menu.add-cart");
                                                    target.removeClass('fadeout');
                                                }, 3000);
                                            },
                                            error: function (jqXHR, textStatus, errorThrown) {
                                                console.log(textStatus, errorThrown);
                                            }
                                        });
                                    } else {
                                        if (typeof failedCallback === 'function') {
                                            let errObj = EnumCoreModule.GetToastStr().Error.ITEM_VISIBILITY_DISABLED_BY_ADMIN_OR_MERCHANT;
                                            if (isComparisonOnly) {
                                                errObj = EnumCoreModule.GetToastStr().Error.FAILED_ADD_DISABLED_ITEM_TO_COMPARISON;
                                            }
                                            failedCallback(errObj);
                                        }

                                        return dispatch({
                                            type: actionTypes.ADD_EDIT_CART,
                                            items: Object.assign({}, e)
                                        });
                                    }
                                },
                                error: function (jqXHR, textStatus, errorThrown) {
                                    console.log(textStatus, errorThrown);
                                }
                            });
                        }
                    } else {
                        const options = {
                            selectedQuantity: priceValues.quantity,
                            discount: priceValues.discount,
                            itemId: e.ID,
                            force: true,
                            isComparisonOnly: false,
                            ServiceBookingUnitGuid: null,
                            bookingSlot: null
                        };

                        window.gtag("event", "add_to_cart", {
                            'app_name': 'Megamak',
                            'item_added': 'Item: ' + e.BuyerDescription
                        })

                        const itemId = options.itemId;
                        const selectedQuantity = options.selectedQuantity || 0;
                        const discount = options.discount || 0;
                        const force = options.force;
                        const isComparisonOnly = options.isComparisonOnly;
                        const serviceBookingUnitGuid = options.serviceBookingUnitGuid || null;
                        const bookingSlot = options.bookingSlot;
                        const addOns = options.addOns;

                        $.ajax({
                            url: '/items/getItemDetails',
                            type: 'GET',
                            data: {
                                itemId: e.ID
                            },
                            success: function (result) {
                                e.IsVisibleToCustomer = result.IsVisibleToCustomer;
                                e.IsAvailable = result.IsAvailable;
                                e.Active = result.Active;

                                if (e.Active) {
                                    let url = '/items/addCart';
                                    let method = 'POST';

                                    if (cartItemId) {
                                        url = '/items/editCart';
                                        method = 'PUT';
                                    }
                                    let guestUserID = "";
                                    if (CommonModule.getCookie("guestUserID") && CommonModule.getCookie("guestUserID") !== "") {
                                        guestUserID = CommonModule.getCookie("guestUserID");
                                    }

                                    //Fix
                                    var quantity = 1;
                                    $.ajax({
                                        url: url,
                                        type: method,
                                        data: {
                                            cartItemId: cartItemId,
                                            quantity: quantity,
                                            discount: discount,
                                            itemId: itemId,
                                            force: force,
                                            forComparison: isComparisonOnly,
                                            guestUserID: guestUserID,                            
                                            serviceBookingUnitGuid: serviceBookingUnitGuid,
                                            bookingSlot: bookingSlot ? JSON.stringify(bookingSlot) : null,
                                            addOns: addOns ? JSON.stringify(addOns) : null,
                                        },
                                        success: function (result) {
                                            if (result.ID == null && result.Code && !options.isComparisonOnly) {
                                                if (result.Code == 'INSUFFICIENT_STOCK') {
                                                    if (typeof failedCallback === 'function') {
                                                        failedCallback(EnumCoreModule.GetToastStr().Error.INSUFFICIENT_STOCK);
                                                    }
                                                } else if (result.Code == 'INVALID_SERVICE_BOOKING') {
                                                    if (typeof failedCallback === 'function') {
                                                    failedCallback(EnumCoreModule.GetToastStr().Error.INVALID_SERVICE_BOOKING);
                                                    }
                                                }
                                            return dispatch({
                                                    type: '',
                                                });
                                            }
                                            if (result.AccessToken && result.AccessToken.UserId) {
                                            CommonModule.createCookie("guestUserID", result.AccessToken.UserId, 1);
                                            }
                                            if (e.HasChildItems && e.ChildItems) {
                                                e.ChildItems.forEach(function (child) {
                                                    if (child.ID === itemId) {
                                                        if (child.StockLimited === true && !isComparisonOnly) {
                                                            //ARC9590
                                                            child.StockQuantity = parseInt(child.StockQuantity) - parseInt(selectedQuantity);
                                                        }
                                                    }
                                                });
                                            } else {
                                                if (!isComparisonOnly) {
                                                    e.StockQuantity = parseInt(e.StockQuantity) - parseInt(selectedQuantity);
                                                }
                                            }

                                            if (typeof successCallback === 'function') {
                                                successCallback(result);
                                            }

                                            if (typeof window !== "undefined" && typeof document !== "undefined") {
                                                //toastr.success("Artículo agregado al carrito.");
                                                document.getElementById('latest-cart-count').innerText = parseInt(document.getElementById('latest-cart-count').innerText) + parseInt(priceValues.quantity);
                                                $(".h-cart .h-dd-menu.add-cart").addClass('fadeout');
                                                $('.h-cart .h-dd-menu.add-cart.fadeout').css('display', '');


                                                $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > p').text(Name);
                                                $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > .item-price > .currency').text(`${CurrencyCode} ${Currency(CurrencyCode)}`);
                                                $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > .item-price > .value').text(priceItem);
                                                $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-img > img').attr('src', Media[0].MediaUrl);

                                                
                                                setTimeout(function () {
                                                    var target = $(".h-cart .h-dd-menu.add-cart");
                                                    target.removeClass('fadeout');
                                                }, 3000);
                                            } else {
                                                $(".h-cart .h-dd-menu.add-cart").addClass('fadeout');
                                                $('.h-cart .h-dd-menu.add-cart.fadeout').css('display', '');


                                                $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > p').text(Name);
                                                $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > .item-price > .currency').text(`${CurrencyCode} ${Currency(CurrencyCode)}`);
                                                $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > .item-price > .value').text(priceItem);
                                                $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-img > img').attr('src', Media[0].MediaUrl);

                                                
                                                setTimeout(function () {
                                                    var target = $(".h-cart .h-dd-menu.add-cart");
                                                    target.removeClass('fadeout');
                                                }, 3000);
                                            }
                                        },
                                        error: function (jqXHR, textStatus, errorThrown) {
                                            console.log(textStatus, errorThrown);
                                            toastr.error("No se pudo agregar al carrito.");
                                        }
                                    });
                                } else {
                                    toastr.error("No se pudo agregar al carrito.");
                                    if (typeof failedCallback === 'function') {
                                        let errObj = EnumCoreModule.GetToastStr().Error.ITEM_VISIBILITY_DISABLED_BY_ADMIN_OR_MERCHANT;
                                        if (isComparisonOnly) {
                                            errObj = EnumCoreModule.GetToastStr().Error.FAILED_ADD_DISABLED_ITEM_TO_COMPARISON;
                                        }
                                        failedCallback(errObj);
                                    }

                                    return dispatch({
                                        type: actionTypes.ADD_EDIT_CART,
                                        items: Object.assign({}, e)
                                    });
                                }
                            },
                            error: function (jqXHR, textStatus, errorThrown) {
                                console.log(textStatus, errorThrown);
                            }
                        });
                    }
                });
            } else {
                userIsB2C = window.REDUX_DATA.userReducer.user.CustomFields.find(x => x.Name == "Tipo de Usuario").Values[0];

                if(userIsB2C == "B2B") {
                    try {
                        if (self.props.processing === true) {
                            return;
                        }
                    } catch(error) {
                    }

                    $('.minimum-order-not-met-error-container').hide();
                    $('.not-enough-stock-error-container').hide();
                    $('.required').removeClass('error-con');
                    try {
                        if (self.props.user.Guest && self.props.controlFlags.GuestCheckoutEnabled === false) {
                            toastr.error('Feature not available yet for guest user.')
                            return;
                        }
                    } catch(error) {
                    }

                    var numQty = e.CustomFields.find(x => x.Code == process.env.CF_SALES_UNIT);

                    var priceValues = {
                        quantity: numQty.Values[0]
                    };

                    let guestUserID = "";
                    //if (!self.props.user) {
                        if (CommonModule.getCookie("guestUserID") && CommonModule.getCookie("guestUserID") !== "") {
                            guestUserID = CommonModule.getCookie("guestUserID");
                        }
                    ///} else {
                    ///    userId = self.props.user.ID;
                    //}

                    console.log("guestUserID " + guestUserID);
                        //console.log("userId " + userId);

                    const options = {
                            pageSize: 1000,
                            pageNumber: 1,
                            includes: null,
                            guestUserID: guestUserID
                        };

                    let APIurl = "/cart/getUserCarts?pageSize=" + options.pageSize + "&pageNumber=" + options.pageNumber + "&includes=" + options.includes + "&guestUserID=" + options.guestUserID;

                    var settings = {
                        "url": APIurl,
                        "method": "GET",
                        "timeout": 0,
                    };

                    $.ajax(settings).done(function (response) {
                        let cartList = [];
                        let cartCount = 0;
                        if (response.TotalRecords > 0 && response.Records) {
                            cartList = response.Records;
                            cartList.map(cart => cartCount += parseInt(cart.Quantity || 0));
                        }

                        cartList.map(function (cart) {
                            //ARC10053 the discountamount should not be round off to have the correct value.
                            if (cart.DiscountAmount) {
                                cart.DiscountAmount = parseFloat(cart.DiscountAmountNotRoundOff) || 0;
                            }
                        });

                        let quantityToPass = priceValues.quantity;
                        let cartItemId = null;
                        const itemExistsInCartLocal = cartList.find(cl => cl.ItemDetail.ID == e.ID);
                        if (process.env.PRICING_TYPE != 'service_level') {
                            const itemExistsInCart = cartList.find(cl => cl.ItemDetail.ID == e.ID);
                            cartItemId = itemExistsInCart ? itemExistsInCart.ID : null;
                            if (itemExistsInCart) {
                                quantityToPass = parseInt(priceValues.quantity) + parseInt(itemExistsInCart.Quantity);
                            }
                        }
                        if(itemExistsInCartLocal){
                            var itemQty = itemExistsInCartLocal.Quantity;
                            var qtyFinal = itemQty;
                            if ((qtyFinal + priceValues.quantity) > parseInt(priceValues.quantity) && self.isThisUserB2C === true) {
                                toastr.error('No hay suficiente stock para este producto, puedes contactar al vendedor para más información.', 'Error');
                                //self.props.setProcessing(false);
                                return;
                            } else {
                                const options = {
                                    selectedQuantity: priceValues.quantity,
                                    discount: priceValues.discount,
                                    itemId: e.ID,
                                    force: true,
                                    isComparisonOnly: false,
                                    ServiceBookingUnitGuid: null,
                                    bookingSlot: null
                                };

                                window.gtag("event", "add_to_cart", {
                                    'app_name': 'Megamak',
                                    'item_added': 'Item: ' + e.BuyerDescription
                                });

                                const itemId = options.itemId;
                                const selectedQuantity = options.selectedQuantity || 0;
                                const discount = options.discount || 0;
                                const force = options.force;
                                const isComparisonOnly = options.isComparisonOnly;
                                const serviceBookingUnitGuid = options.serviceBookingUnitGuid || null;
                                const bookingSlot = options.bookingSlot;
                                const addOns = options.addOns;

                                $.ajax({
                                    url: '/items/getItemDetails',
                                    type: 'GET',
                                    data: {
                                        itemId: e.ID
                                    },
                                    success: function (result) {
                                        e.IsVisibleToCustomer = result.IsVisibleToCustomer;
                                        e.IsAvailable = result.IsAvailable;
                                        e.Active = result.Active;

                                        if (e.Active) {
                                            let url = '/items/addCart';
                                            let method = 'POST';

                                            if (cartItemId) {
                                                url = '/items/editCart';
                                                method = 'PUT';
                                            }
                                            let guestUserID = "";
                                            if (CommonModule.getCookie("guestUserID") && CommonModule.getCookie("guestUserID") !== "") {
                                                guestUserID = CommonModule.getCookie("guestUserID");
                                            }

                                            //fix
                                            var quantity = 1;
                                            $.ajax({
                                                url: url,
                                                type: method,
                                                data: {
                                                    cartItemId: cartItemId,
                                                    quantity: quantity,
                                                    discount: discount,
                                                    itemId: itemId,
                                                    force: force,
                                                    forComparison: isComparisonOnly,
                                                    guestUserID: guestUserID,                            
                                                    serviceBookingUnitGuid: serviceBookingUnitGuid,
                                                    bookingSlot: bookingSlot ? JSON.stringify(bookingSlot) : null,
                                                    addOns: addOns ? JSON.stringify(addOns) : null,
                                                },
                                                success: function (result) {
                                                    if (result.ID == null && result.Code && !options.isComparisonOnly) {
                                                        if (result.Code == 'INSUFFICIENT_STOCK') {
                                                            if (typeof failedCallback === 'function') {
                                                                failedCallback(EnumCoreModule.GetToastStr().Error.INSUFFICIENT_STOCK);
                                                            }
                                                        } else if (result.Code == 'INVALID_SERVICE_BOOKING') {
                                                            if (typeof failedCallback === 'function') {
                                                            failedCallback(EnumCoreModule.GetToastStr().Error.INVALID_SERVICE_BOOKING);
                                                            }
                                                        }
                                                    return dispatch({
                                                            type: '',
                                                        });
                                                    }
                                                    if (result.AccessToken && result.AccessToken.UserId) {
                                                    CommonModule.createCookie("guestUserID", result.AccessToken.UserId, 1);
                                                    }
                                                    if (e.HasChildItems && e.ChildItems) {
                                                        e.ChildItems.forEach(function (child) {
                                                            if (child.ID === itemId) {
                                                                if (child.StockLimited === true && !isComparisonOnly) {
                                                                    //ARC9590
                                                                    child.StockQuantity = parseInt(child.StockQuantity) - parseInt(selectedQuantity);
                                                                }
                                                            }
                                                        });
                                                    } else {
                                                        if (!isComparisonOnly) {
                                                            e.StockQuantity = parseInt(e.StockQuantity) - parseInt(selectedQuantity);
                                                        }
                                                    }

                                                    if (typeof successCallback === 'function') {
                                                        successCallback(result);
                                                    }

                                                    if (typeof window !== "undefined" && typeof document !== "undefined") {
                                                        //toastr.success("Artículo agregado al carrito.");
                                                        document.getElementById('latest-cart-count').innerText = parseInt(document.getElementById('latest-cart-count').innerText) + parseInt(priceValues.quantity);
                                                        $(".h-cart .h-dd-menu.add-cart").addClass('fadeout');
                                                        $('.h-cart .h-dd-menu.add-cart.fadeout').css('display', '');


                                                        $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > p').text(Name);
                                                        $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > .item-price > .currency').text(`${CurrencyCode} ${Currency(CurrencyCode)}`);
                                                        $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > .item-price > .value').text(priceItem);
                                                        $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-img > img').attr('src', Media[0].MediaUrl);

                                                        
                                                        setTimeout(function () {
                                                            var target = $(".h-cart .h-dd-menu.add-cart");
                                                            target.removeClass('fadeout');
                                                        }, 3000);
                                                    } else {
                                                        $(".h-cart .h-dd-menu.add-cart").addClass('fadeout');
                                                        $('.h-cart .h-dd-menu.add-cart.fadeout').css('display', '');


                                                        $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > p').text(Name);
                                                        $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > .item-price > .currency').text(`${CurrencyCode} ${Currency(CurrencyCode)}`);
                                                        $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > .item-price > .value').text(priceItem);
                                                        $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-img > img').attr('src', Media[0].MediaUrl);

                                                        setTimeout(function () {
                                                            var target = $(".h-cart .h-dd-menu.add-cart");
                                                            target.removeClass('fadeout');
                                                        }, 3000);
                                                    }
                                                },
                                                error: function (jqXHR, textStatus, errorThrown) {
                                                    console.log(textStatus, errorThrown);
                                                }
                                            });
                                        } else {
                                            if (typeof failedCallback === 'function') {
                                                let errObj = EnumCoreModule.GetToastStr().Error.ITEM_VISIBILITY_DISABLED_BY_ADMIN_OR_MERCHANT;
                                                if (isComparisonOnly) {
                                                    errObj = EnumCoreModule.GetToastStr().Error.FAILED_ADD_DISABLED_ITEM_TO_COMPARISON;
                                                }
                                                failedCallback(errObj);
                                            }

                                            return dispatch({
                                                type: actionTypes.ADD_EDIT_CART,
                                                items: Object.assign({}, e)
                                            });
                                        }
                                    },
                                    error: function (jqXHR, textStatus, errorThrown) {
                                        console.log(textStatus, errorThrown);
                                    }
                                });
                            }
                        } else {
                            const options = {
                                selectedQuantity: priceValues.quantity,
                                discount: priceValues.discount,
                                itemId: e.ID,
                                force: true,
                                isComparisonOnly: false,
                                ServiceBookingUnitGuid: null,
                                bookingSlot: null
                            };

                            window.gtag("event", "add_to_cart", {
                                'app_name': 'Megamak',
                                'item_added': 'Item: ' + e.BuyerDescription
                            })

                            const itemId = options.itemId;
                            const selectedQuantity = options.selectedQuantity || 0;
                            const discount = options.discount || 0;
                            const force = options.force;
                            const isComparisonOnly = options.isComparisonOnly;
                            const serviceBookingUnitGuid = options.serviceBookingUnitGuid || null;
                            const bookingSlot = options.bookingSlot;
                            const addOns = options.addOns;

                            $.ajax({
                                url: '/items/getItemDetails',
                                type: 'GET',
                                data: {
                                    itemId: e.ID
                                },
                                success: function (result) {
                                    e.IsVisibleToCustomer = result.IsVisibleToCustomer;
                                    e.IsAvailable = result.IsAvailable;
                                    e.Active = result.Active;

                                    if (e.Active) {
                                        let url = '/items/addCart';
                                        let method = 'POST';

                                        if (cartItemId) {
                                            url = '/items/editCart';
                                            method = 'PUT';
                                        }
                                        let guestUserID = "";
                                        if (CommonModule.getCookie("guestUserID") && CommonModule.getCookie("guestUserID") !== "") {
                                            guestUserID = CommonModule.getCookie("guestUserID");
                                        }

                                        //Fix
                                        var quantity = 1;
                                        $.ajax({
                                            url: url,
                                            type: method,
                                            data: {
                                                cartItemId: cartItemId,
                                                quantity: quantity,
                                                discount: discount,
                                                itemId: itemId,
                                                force: force,
                                                forComparison: isComparisonOnly,
                                                guestUserID: guestUserID,                            
                                                serviceBookingUnitGuid: serviceBookingUnitGuid,
                                                bookingSlot: bookingSlot ? JSON.stringify(bookingSlot) : null,
                                                addOns: addOns ? JSON.stringify(addOns) : null,
                                            },
                                            success: function (result) {
                                                if (result.ID == null && result.Code && !options.isComparisonOnly) {
                                                    if (result.Code == 'INSUFFICIENT_STOCK') {
                                                        if (typeof failedCallback === 'function') {
                                                            failedCallback(EnumCoreModule.GetToastStr().Error.INSUFFICIENT_STOCK);
                                                        }
                                                    } else if (result.Code == 'INVALID_SERVICE_BOOKING') {
                                                        if (typeof failedCallback === 'function') {
                                                        failedCallback(EnumCoreModule.GetToastStr().Error.INVALID_SERVICE_BOOKING);
                                                        }
                                                    }
                                                return dispatch({
                                                        type: '',
                                                    });
                                                }
                                                if (result.AccessToken && result.AccessToken.UserId) {
                                                CommonModule.createCookie("guestUserID", result.AccessToken.UserId, 1);
                                                }
                                                if (e.HasChildItems && e.ChildItems) {
                                                    e.ChildItems.forEach(function (child) {
                                                        if (child.ID === itemId) {
                                                            if (child.StockLimited === true && !isComparisonOnly) {
                                                                //ARC9590
                                                                child.StockQuantity = parseInt(child.StockQuantity) - parseInt(selectedQuantity);
                                                            }
                                                        }
                                                    });
                                                } else {
                                                    if (!isComparisonOnly) {
                                                        e.StockQuantity = parseInt(e.StockQuantity) - parseInt(selectedQuantity);
                                                    }
                                                }

                                                if (typeof successCallback === 'function') {
                                                    successCallback(result);
                                                }

                                                if (typeof window !== "undefined" && typeof document !== "undefined") {
                                                    //toastr.success("Artículo agregado al carrito.");
                                                    document.getElementById('latest-cart-count').innerText = parseInt(document.getElementById('latest-cart-count').innerText) + parseInt(priceValues.quantity);
                                                    $(".h-cart .h-dd-menu.add-cart").addClass('fadeout');
                                                    $('.h-cart .h-dd-menu.add-cart.fadeout').css('display', '');


                                                    $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > p').text(Name);
                                                    $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > .item-price > .currency').text(`${CurrencyCode} ${Currency(CurrencyCode)}`);
                                                    $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > .item-price > .value').text(priceItem);
                                                    $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-img > img').attr('src', Media[0].MediaUrl);

                                                    setTimeout(function () {
                                                        var target = $(".h-cart .h-dd-menu.add-cart");
                                                        target.removeClass('fadeout');
                                                    }, 3000);
                                                } else {
                                                    $(".h-cart .h-dd-menu.add-cart").addClass('fadeout');
                                                    $('.h-cart .h-dd-menu.add-cart.fadeout').css('display', '');


                                                    $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > p').text(Name);
                                                    $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > .item-price > .currency').text(`${CurrencyCode} ${Currency(CurrencyCode)}`);
                                                    $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > .item-price > .value').text(Price);
                                                    $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-img > img').attr('src', Media[0].MediaUrl);

                                                    
                                                    setTimeout(function () {
                                                        var target = $(".h-cart .h-dd-menu.add-cart");
                                                        target.removeClass('fadeout');
                                                    }, 3000);
                                                }
                                            },
                                            error: function (jqXHR, textStatus, errorThrown) {
                                                console.log(textStatus, errorThrown);
                                            }
                                        });
                                    } else {
                                        if (typeof failedCallback === 'function') {
                                            let errObj = EnumCoreModule.GetToastStr().Error.ITEM_VISIBILITY_DISABLED_BY_ADMIN_OR_MERCHANT;
                                            if (isComparisonOnly) {
                                                errObj = EnumCoreModule.GetToastStr().Error.FAILED_ADD_DISABLED_ITEM_TO_COMPARISON;
                                            }
                                            failedCallback(errObj);
                                        }

                                        return dispatch({
                                            type: actionTypes.ADD_EDIT_CART,
                                            items: Object.assign({}, e)
                                        });
                                    }
                                },
                                error: function (jqXHR, textStatus, errorThrown) {
                                    console.log(textStatus, errorThrown);
                                }
                            });
                        }
                    });
                } else {
                    toastr.error("El artículo no cuenta con existencias.");
                }
            }
        } catch(error) {

        }
    }

    getMoq() {
        const { ChildItems } = self.props.itemDetails;
        let moq = '';

        if (ChildItems && ChildItems.length > 0) {
            const { CustomFields } = ChildItems[0];

            if (CustomFields && CustomFields.length > 0) {
                const moqCustomField = CustomFields.find(c => c.Code.startsWith('moq'));

                if (moqCustomField && moqCustomField.Values && moqCustomField.Values.length > 0) {
                    moq = parseFloat(moqCustomField.Values[0]).toFixed();
                }
            }
        }

        return moq;
    }

    render() {
        setTimeout(() => {
            this.loadSalePrices();
        }, 1000);

        var self = this;
            return (                      
                <div className="items-content behavior2 search-result-container item-search-res" id="items-list">
                    {Array.from(self.props.items).map(function (item, index) {
                        const { AverageRating } = item;
                        const stars = AverageRating ? AverageRating * 20 : 0;
                        
                        var itemCorePrice = item.CustomFields.find(x => x.Code == process.env.CF_CORE_PRICE).Values[0];
                        var strPartCode = item.CustomFields.find(x => x.Code === process.env.CF_PART_NUMBER).Values[0];
                        
                        let partNumberCf;
                        try {
                            partNumberCf = item.CustomFields.find(x => x.Code == process.env.CF_PART_NUMBER);
                        } catch (error) {
                            console.error(".Find error:", error);
                        }
                        let partNumber = "";

                        if (partNumberCf != undefined) {
                            partNumber = partNumberCf.Values[0];
                        }

                        const requestBody = {
                            "operatingUnitId": 446,
                            "partsCode": [
                                {
                                    "partCode": partNumber
                                }
                            ]
                        };
                        const promiseapilider = client.Availability.GetAvalability(requestBody);
                        Promise.all([promiseapilider]).then(response => {
                            console.log("lider");
                            console.log(response);
                            let avalabilityes = response[0].Parts[0].Availabilitys;
                            let avalabilityesTotal = 0;
                            avalabilityes.forEach(element => {
                                avalabilityesTotal = element.Availability+avalabilityesTotal;
                            })

                            var colorCart = 'btnaddCart btn-group btn-cart';

                            if(avalabilityesTotal == 0)
                            {     
                                colorCart += ' disabled';
                                if (typeof window !== "undefined" && typeof document !== "undefined") {
                                    if(document.getElementById("cartExistenciasSearch" + response[0].Parts[0].PartCode)) {
                                        document.getElementById("cartExistenciasSearch" + response[0].Parts[0].PartCode).className = colorCart;
                                    }
                                }
                            } else {
                                if (typeof window !== "undefined" && typeof document !== "undefined") {
                                    if (document.getElementById("cartExistenciasSearch" + response[0].Parts[0].PartCode)) {
                                        document.getElementById("cartExistenciasSearch" + response[0].Parts[0].PartCode).className = colorCart;
                                    }
                                }
                            }

                            if (typeof window !== "undefined" && typeof document !== "undefined") {
                                if(document.getElementById("existenciasSearch" + response[0].Parts[0].PartCode)) {
                                    document.getElementById("existenciasSearch" + response[0].Parts[0].PartCode).innerText = avalabilityesTotal;
                                }
                            }
                        });
                        //TODO: Delete, is not necessary due search API convert prices at response
                        if(process.env.BASE_URL == "bepensab2c.staging.arcadier.io"){
                            var strCurrencyCode = "";
                            var currencyCodeCf = item.CustomFields.find(x => x.Name == "Currency");   
                            if (currencyCodeCf != undefined || currencyCodeCf != null) {
                                if(currencyCodeCf.Values[0].length > 0){
                                    strCurrencyCode = currencyCodeCf.Values[0];
                                }                       
                            }                    
                            if(self.state != null && self.state.currentExchange != null && self.state.currentExchange != "-"){
                    
                                let strMXNPrice = item.Price;
                    
                                if(strCurrencyCode != "MXN"){
                                    strMXNPrice = item.Price * self.state.currentExchange;
                                }                        
                                item.Price = strMXNPrice;
                            }
                        }

                        var classPrecioCore = '';
                        var classNumeroParte = '';
                        if(itemCorePrice == 0) {
                            classPrecioCore = 'hide';
                        } /*else {
                            itemCorePrice = itemCorePrice * self.state.currentExchange;
                        }*/

                        if(item.Name.includes(strPartCode)){
                            classNumeroParte = 'hide';
                        }

                        //let classes = '';

        //if(this.isThisUserB2C()){
            //Cart funcionality
            ///classes += ' disabled';

                        var colorCart = 'btnaddCart btn-group btn-cart';
                        var cantidadExistencia = 0;
                        if(item.StockQuantity == -1) {
                            cantidadExistencia = 100;
                        } else {
                            cantidadExistencia = item.StockQuantity;
                            if(cantidadExistencia == 0)
                            {     
                                colorCart += ' disabled';
                            }
                        }
                        return (
                            <div className="item-box" key={item.ID}>
                                {self.state.boolIsCalculate &&
                                <div>
                                    <a href={"/items/" + self.generateSlug(item.Name) + "/" + item.ID + "?name="+ item.Name}>
                                        <div style={{width: "180px", height:"180px"}} className="item-image">
                                            <img alt="" src={item.Media && item.Media.length > 0 ? item.Media[0].MediaUrl : ''} />
                                        </div>
                                    </a>
                                        <div className="item-info" style={{display: "block", maxWidth: "180px", margin: "auto"}}>
                                            <div className="item-desc">
                                                <p className={"item-name " + classNumeroParte}>{strPartCode}</p>
                                                <p className="item-name">{item.Name}</p>
                                                {/*self.props.reviewAndRating === true ? self.renderRating(stars):''*/}
                                                <div>Existencias: <label id={"existenciasSearch" + partNumber}>{cantidadExistencia}</label>
                                                </div>
                                                <div className={{ colorCart }}
                                                    style={{padding: "5px", fontSize: "12px" }}
                                                    id={"cartExistenciasSearch" + partNumber}
                                                    onClick={(e) => self.addItemToCart(item)}>
                                                    Comprar
                                                </div>
                                                <div className="item-price" style={{paddingTop: "10px"}}>
                                                    <div>
                                                        <span id={"precioPublico" + strPartCode}><b>$ {self.subFormatMoney(item.Price)} MXN</b></span><br/>
                                                        <span id={"precioDescuento" + strPartCode}></span>
                                                    </div>
                                                    {self.renderOffer(item, classPrecioCore)}
                                                    <label style={{ fontSize: '12px'}} className={classPrecioCore}>Precio CORE: $ {self.subFormatMoney(itemCorePrice)/*self.renderFormatMoney("MXN", itemCorePrice)*/} MXN</label>
                                                </div>
                                                {/*<p className="item-seller">{item.MerchantDetail.DisplayName} </p>*/}
                                            </div>
                                        </div>
                                </div>
                                }
                            </div>
                            );
                    })}
                </div>
                
            );
   }
}

module.exports = SearchItemViewComponent;
